import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/landing/dist/king/@section4/index.js");
